import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';
import PrivacyPolicyItem from 'blocks/PrivacyPolicyItem/PrivacyPolicyItem';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { IGenericPage } from 'types/interfaces';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import { privacy_policy } from 'data/translationKeys';
import data from 'data/privacypolicy.json';
import { PrivacyPolicyType } from 'types/types';
import DownloadApp from 'blocks/DownloadApp/DownloadApp';

const PrivacyPolicy: NextPage<IGenericPage> = ({ globalLayoutProps }) => {
  const privacy_policy_text = useLocalised(privacy_policy);

  return (
    <GlobalLayout {...globalLayoutProps}>
      <div className="privacy-policy-page">
        <h1 className="privacy-policy-page__title">{privacy_policy_text}</h1>
        <div className="privacy-policy-page__content">
          {(data as PrivacyPolicyType[]).map((item, index) => (
            <PrivacyPolicyItem
              key={index}
              title={item.title}
              privacyPolicies={item.list}
            />
          ))}
        </div>
      </div>
      <DownloadApp />
    </GlobalLayout>
  );
};

export default PrivacyPolicy;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.PRIVACY_POLICY,
  });

  return {
    props: {
      ...genericPageProps,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
